<style lang="less">
	@import "../assets/css/common.css";
	@import "../assets/css/index.less";
</style>
<template>
	<div class="index">
		<header>
			<div class="w1100 clearfix">
				<div class="logo">
					<img src="../assets/img/small_logo.jpg" />
				</div>
				<nav>
					<ul class="clearfix">
						<li><router-link :class="url=='/'?'active':''" to="/">首页</router-link></li>
						<li class="li_two"><router-link :class="url!='/'&&url!='/about'?'active':''" to="/business">产品与业务</router-link></li>
						<li><router-link :class="url=='/about'?'active':''" to="/about">关于我们</router-link></li>
					</ul>
				</nav>
			</div>
		</header>

		<router-view/>

		<footer>
			<div class="w1100 companyInfo clearfix">
				<div class="left">
					<h4>周一到周五9:00-18:00(北京时间)</h4>
					<ul>
						<li><img src="../assets/img/n_phone.png" /><p>01064935308</p></li>
						<li><img src="../assets/img/n_email.png" /><p>caoyan@huiyuenet.cn &nbsp;\&nbsp; maming@huiyuenet.cn</p></li>
						<li><img src="../assets/img/n_address.png" /><p>北京朝阳区双营路11号美立方4号楼2单元1206</p></li>
					</ul>
				</div>
				<div class="right">
					<img src="../assets/img/qrcode_for_gh_7b935093f8d9_344.jpg" />
					<p>扫码关注公众号</p>
				</div>
			</div>
			<div class="copy">
				<p><router-link :class="url=='/'?'active':''" to="/protocol"><span style="color: #FAFFF2;">慧阅隐私政策</span></router-link>&nbsp;|&nbsp;copyright 2013-2023&nbsp;&nbsp;www.huiyuenet.cn&nbsp;&nbsp;all rights reserved&nbsp;&nbsp;北京慧阅信息服务有限公司&nbsp;&nbsp;版权所有&nbsp;&nbsp;<a href="http://beian.miit.gov.cn" target="_blank"><span style="color: #FAFFF2;">京ICP备20030867号</span></a></p>
			</div>
		</footer>
	</div>


</template>

<script>
	// import { swiper, swiperSlide } from 'vue-awesome-swiper'
	export default {
		name:'index',
		// components: {
		// 	swiper,
		// 	swiperSlide
		// },
		data() {
			return {
				url:''
			};
		},
		created(){
			this.url=this.$route.path;
		},
		updated: function () {
			this.url=this.$route.path;
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/index.vue